import initialState from "./initialState";

export function StationInvoiceParameterReducer(
  state = initialState.StationInvoiceSearchInfo,
  action
) {
  switch (action.type) {
    case "STATION_INV_SELECTION_REQUEST":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
